import { render } from "./DefaultCourses.vue?vue&type=template&id=63862184&scoped=true"
import script from "./DefaultCourses.vue?vue&type=script&lang=js"
export * from "./DefaultCourses.vue?vue&type=script&lang=js"

import "./DefaultCourses.vue?vue&type=style&index=0&id=63862184&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63862184"]])

export default __exports__